import { render, staticRenderFns } from "./EstimateTaskDefaultsForm.vue?vue&type=template&id=e3c5a4f0&"
import script from "./EstimateTaskDefaultsForm.vue?vue&type=script&lang=ts&"
export * from "./EstimateTaskDefaultsForm.vue?vue&type=script&lang=ts&"
import style0 from "./EstimateTaskDefaultsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports